module.exports = __webpack_public_path__ + "static/media/hb-tmp.b3487028.svg";